<p>global-table works!</p>
